<template>
    <div id="Window">
        <h1>MUSHROOM CONTROL</h1>
        <div class="card">
            <h2>Approve Tokens</h2>
            <button class="button" @click="approveAll()">Approve</button>
        </div>

        <div class="card">
            <h2>Mint a mushroom!</h2>
            <label for="name">Name</label>
            <input class="textInput" name="name" v-model="name" />
            <button class="button" @click="mintShroom(this.name)">Mint</button>
        </div>
        <div class="card">
            <h2>Change an accessory!</h2>
            <label for="ID">Token ID</label>
            <input class="textInput" name="ID" v-model="AtokenID" />
            <label for="Accessory">Accessory</label>
            <input class="textInput" name="Accessory" v-model="accessoryID" />
            <button class="button" @click="changeAccessory(this.AtokenID, this.accessoryID)">Change</button>
        </div>

        <div class="card">
            <h2>Age your shroom!</h2>
            <label for="ID">Token ID</label>
            <input class="textInput" name="ID" v-model="AtokenID" />
            <button class="button" @click="age(this.AtokenID)">Age</button>
        </div>

        <div class="card">
            <h2>Get shroom!</h2>
            <label for="ID">Token ID</label>
            <input class="textInput" name="ID" v-model="AtokenID" />
            <button class="button" @click="getShroom(this.AtokenID)">Age</button>
        </div>


        <div class="card">
            <h2>Add a location!</h2>
            <label for="title">Title</label>
            <input class="textInput" name="title" v-model="title" />

            <label for="description">description</label>
            <input class="textInput" name="description" v-model="description" />

            <label for="imageURI">imageURI</label>
            <input class="textInput" name="imageURI" v-model="imageURI" />

            <label for="xCoord">xCoord</label>
            <input class="textInput" name="xCoord" v-model="xCoord" />

            <label for="yCoord">yCoord</label>
            <input class="textInput" name="yCoord" v-model="yCoord" />

            <label for="xpValue">xpValue</label>
            <input class="textInput" name="xpValue" v-model="xpValue" />

            <button class="button" @click="addLocation(this.title, this.description, this.imageURI, this.xCoord, this.yCoord, this.xpValue)">Add Location</button>
        </div>

        <div class="card">
            <h2>Add a Truffle!</h2>
            <label for="locationId">location ID</label>
            <input class="textInput" name="locationId" v-model="locationId" />

            <label for="shroomId">shroom ID</label>
            <input class="textInput" name="shroomId" v-model="shroomId" />

            <label for="message">message</label>
            <input class="textInput" name="message" v-model="message" />

            <button class="button" @click="addTruffle(this.locationId, this.shroomId, this.message)">Add Truffle</button>
        </div>
    </div>
</template>

<script>

import {ethers} from "ethers";

export default {
    name: 'inter',
    data() {
        return {
        name:"",
        AtokenID: null,
        accessoryID: null,
        ageTokenID: null,
        title: "",
        description: "",
        imageURI: "",
        xCoord: 0,
        yCoord: 0,
        required: [],
        xpValue: 0,
        locationId: 0,
        shroomId: 1,
        message: ""
        }
    },
    computed: {

    },
    methods: {
        async approveAll(){
            try{
                const provider = new ethers.providers.Web3Provider(ethereum);
                const signer = provider.getSigner();
                const itemTract = new ethers.Contract(this.$store.state.shroomItems_address, this.$store.state.shroomItems_abi, signer);

                let txn = await itemTract.setApprovalForAll(this.$store.state.accessoryHandling_Contract, true);
            } catch(error) {
                console.log(error);
            }
        },
        async mintShroom(name) {
            try{
                const provider = new ethers.providers.Web3Provider(ethereum);
                const signer = provider.getSigner();
                const shroomTract = new ethers.Contract(this.$store.state.contract_address, this.$store.state.contract_abi, signer);

                let txn = await shroomTract.mintShroomy(name);
                await txn.wait();
                console.log('Shroom minted!');
            } catch(error){
                console.log(error);
            }
        },
        async changeAccessory(tokenID, accessory) {
            try{
                const provider = new ethers.providers.Web3Provider(ethereum);
                const signer = provider.getSigner();
                const shroomTract = new ethers.Contract(this.$store.state.contract_address, this.$store.state.contract_abi, signer);

                let txn = await shroomTract.changeAccessories(tokenID, accessory);
                await txn.wait();
                console.log('Accessory Changed!');
            } catch(error){
                console.log(error);
            }
        },

        async age(tokenID) {
            try{
                const provider = new ethers.providers.Web3Provider(ethereum);
                const signer = provider.getSigner();
                const shroomTract = new ethers.Contract(this.$store.state.contract_address, this.$store.state.contract_abi, signer);

                let txn = await shroomTract.ageShroom(tokenID);
                await txn.wait();
                console.log('Aged!');
            } catch(error){
                console.log(error);
            }
        },
            async getShroom(tokenID) {
            try{
                const provider = new ethers.providers.Web3Provider(ethereum);
                const signer = provider.getSigner();
                const shroomTract = new ethers.Contract(this.$store.state.contract_address, this.$store.state.contract_abi, signer);

                let txn = await shroomTract.getShroomy(tokenID);
     
                console.log(txn);
            } catch(error){
                console.log(error);
            }
        },

        async addLocation(title, description, imageURI, xCoord, yCoord, xpValue){
            try{
                const provider = new ethers.providers.Web3Provider(ethereum);
                const signer = provider.getSigner();
                const shroomTract = new ethers.Contract(this.$store.state.mushroomHuntContract, this.$store.state.mushroomHuntABI, signer);

                let txn = await shroomTract.addLocation(title, description, imageURI, xCoord, yCoord, "[]", xpValue);
                await txn.wait();
                console.log('Location added!');
            } catch(error){
                console.log(error);
            }
        },
        
        async addTruffle(locationId, mushroomId, message){
            try{
                const provider = new ethers.providers.Web3Provider(ethereum);
                const signer = provider.getSigner();
                const shroomTract = new ethers.Contract(this.$store.state.mushroomHuntContract, this.$store.state.mushroomHuntABI, signer);

                let txn = await shroomTract.addToTruffleBox(locationId, mushroomId, message);
                await txn.wait();
                console.log('Truffle Added!');
            } catch(error){
                console.log(error);
            }
        }

    }

}
</script>

<style scoped>
    #Window {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 35%;
    height: 15%;
    padding-bottom: 5vh;
    padding-top: 3vh;
    padding-left: 5%;
    padding-right: 5%;
    margin-top: 5%;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
    border: 0.5px solid rgba(255,255,255,0.1);
    background-image: linear-gradient(135deg, rgba(255,255,255,0.3), rgba(255,255,255,0.1), rgba(255,255,255,0.1));
    filter: blur(5);
    box-shadow: 0px 0px 24px rgba(0,0,0,0.1);
    }

    .card{
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 3%;
        border-radius: 5px;
        border: 0.5px solid rgba(255,255,255,0.1);
        background-image: linear-gradient(135deg, rgba(255,255,255,0.3), rgba(255,255,255,0.1), rgba(255,255,255,0.1));
        filter: blur(5);
        box-shadow: 0px 0px 24px rgba(0,0,0,0.1);
    }

    .button{
        width: 20%;
        height: 5%;
        margin: auto;
        margin-bottom: 5%;
        border: none;
        border-radius: 5px;
        background-color: white;
        filter: drop-shadow(10px 10px 15px rgba(14, 14, 14, 0.1));
    }

    .textInput{
        margin-left: 4%;
        margin-right: 4%;
        margin-top: 1%;
        margin-bottom: 3%;
    }
</style>